<template>
<DIV
  class="badge border"
  v-if="loaded"
>
  <ItpIcon
    icon="material-symbols:calendar-month"
  >
  </ItpIcon>
  <span
    v-if="value.description"
  >
    {{ value.description }}
  </span>
  <span
    v-if="!value.description"
  >
    <span>
      {{ anchorOptions[value.anchor].name }}
    </span>
    <span
      v-if="value.offset_days"
    >
      <span>
        {{ value.offset_days > 0 ? '+' : '-' }}
      </span>
      <span>
        {{ value.offset_days }}
      </span>
    </span>
  </span>
</DIV>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcBillingDateRuleDisplay extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: Object,
  })
  value!: object;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  anchorOptions!: any;

  async $$load_anchorOptions() {
    return this.$app.repo.get('ui_metadata', { path: 'billing_date_rule_anchor_options', map: true, key: 'value' })
  }

  ux!: any;
  dataMembers = ['anchorOptions', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        anchorOptions: null,
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcBillingDateRuleDisplay", UcBillingDateRuleDisplay);

</script>